/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useUniqueId } from '@squiz/dxp-console-support';
import React, { ChangeEvent } from 'react';
import { ICON_FILTER_LIST } from '../../Icons';
import { TextField } from '../FormFields/fields/TextField';
import { searchFilterDefaults, SearchFilterProps } from './SearchFilter.props';

/**
 * Specialized text field for filtering JSON by keyword.
 */
export const SearchFilter = (props: SearchFilterProps): JSX.Element => {
  const { customIcon, filterValue, label, placeholder, setFilterValue } = { ...searchFilterDefaults, ...props };

  const uniqueId = useUniqueId();

  const handleChange = (event: ChangeEvent): void => {
    const input = event.target as HTMLInputElement;
    const filterValue = input.value;
    setFilterValue(filterValue);
  };

  return (
    <TextField
      classes={`sds-search-filter`}
      customChange={handleChange}
      fieldLabel={label}
      hideLabel
      icon={customIcon ?? ICON_FILTER_LIST}
      id={`search-filter--${uniqueId}`}
      name={`search-filter--${uniqueId}`}
      placeholder={placeholder}
      value={filterValue}
    />
  );
};
